import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PinFixedFill from '@icons/PinFixedFill';
import { NoticeRow } from '@models/notice';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';

interface Props {
    notice: NoticeRow;
}

function NoticeItem({ notice }:Props) {
    const {
        title, content, createdAt, isPinned,
    } = notice;

    const parsed = document.createElement('div');
    parsed.innerHTML = content;
    const imageOnly = parsed.textContent?.length === 0
        && parsed.querySelectorAll('img').length !== 0;
    const imageUrl = (() => {
        if (imageOnly) {
            const img = parsed.querySelector('img');
            return img ? img.getAttribute('src') : null;
        }
        return null;
    })();
    const contentSummary = (() => parsed.textContent?.slice(0, 50))();
    return (
        <Link activityName='NoticeActivity'
            activityParams={{ noticeId: notice.id }}
            css={[containerStyle, pressActionEffect]} >
            {isPinned && (
                <Pin>
                    <PinFixedFill size={20}
                        color={colors.white}/>
                </Pin>
            )}
            <Body spacing={12}
                fullWidth>
                <TitleText size='xl' fontWeight='bold' as='p'>
                    {title}
                </TitleText>
                {imageUrl && (
                    <NoticeImage src={imageUrl}
                        width={296}
                        height={154}
                        alt={title} />
                )}
                {contentSummary && (
                    <Text color={colors.gray7} ellipsis>
                        {contentSummary}
                    </Text>
                )}
            </Body>
            <Footer>
                <Text color={colors.gray6}>
                    {dayjs(createdAt).format('YYYY.MM.DD')}
                </Text>
            </Footer>
        </Link>
    );
}

const containerStyle = css`
    border: 1px solid var(--color-gray3);
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
`;

const Body = styled(Column)`
    padding: 16px 12px;
`;

const Footer = styled.div`
    border-top: 1px solid var(--color-gray3);
    display: flex;
    justify-content: center;
    padding: 8px 0;
    text-align: center;
`;

const TitleText = styled(Text)`
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    width: 100%;
`;

const Pin = styled.div`
    background-color: var(--color-gray7);
    padding: 8px 12px;
    width: 100%;
`;

const NoticeImage = styled(Image)`
    width: 100%;
    height: auto;
`;

export default NoticeItem;
